import styled from 'styled-components'

import { color, fontFamily } from '../../styles'

import { BOTTOM_TOOLBAR_HEIGHT } from './ToolBar/styled'

import { fontSize, fontWeight } from 'src/styles/fonts'
import { media } from 'src/styles/media'

export const Wrap = styled.div`
  width: 100vw;
  height: 100%;
  margin: 0;
  background-image: linear-gradient(238deg, #fffdee 100%, #fef7e2);
`

export const InnerWrap = styled.div`
  height: calc(100% - ${BOTTOM_TOOLBAR_HEIGHT}rem);
  overflow: auto;
  padding-bottom: 3rem;
`

export const FormWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-top: 4rem;
`

export const StyledForm = styled.form`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 2.4rem;

  label {
    margin-bottom: 0.8rem;
  }

  button {
    align-self: center;
    margin-top: 8rem;
  }

  ${media.desktop} {
    width: 50rem;
    margin: 3.2rem 0 8rem 0;
    padding: 0;
  }
`

type InputProps = {
  isError?: boolean
}

export const StyledInput = styled.input<InputProps>`
  height: 4.8rem;
  border-radius: 0.6rem;
  background-color: ${color.WHITE};
  border: solid 0.1rem
    ${({ isError }) => (isError ? `${color.ORANGEY_RED}` : `${color.WHITE}`)};
  padding-left: 1.6rem;
  font-size: ${fontSize.NORMAL};
  line-height: 4.8rem;
  color: ${color.GREYISH_BROWN};
  font-family: ${fontFamily.CATAMARAN};
  min-width: 100%;
  -webkit-appearance: none;

  ::placeholder {
    font-size: ${fontSize.NORMAL};
    color: ${color.PUTTY};
  }

  ::-webkit-calendar-picker-indicator {
    margin-right: 1.6rem;
    cursor: pointer;
  }
`

export const SelectGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0.8rem;
  margin-bottom: 2.4rem;
`

type SelectedButtonProps = {
  isActive: boolean
}

export const SelectButton = styled.div<SelectedButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 4.8rem;
  border-radius: 0.8rem;
  cursor: pointer;
  border: ${(p) =>
    p.isActive ? `solid 0.2rem ${color.DUSTY_ORANGE}` : `none`};
  font-size: ${fontSize.NORMAL};
  line-height: 1.5;
  background-color: ${color.WHITE};
  color: ${(p) =>
    p.isActive ? `${color.DUSTY_ORANGE}` : `${color.GREYISH_BROWN}`};
  font-family: ${fontFamily.CATAMARAN};
  font-weight: ${(p) => (p.isActive ? `600` : `500`)};
`

export const Title = styled.h2`
  font-size: ${fontSize.NORMAL};
  font-weight: ${fontWeight.EXTRA};
  line-height: 1.5;
  color: ${color.GREYISH_BROWN};
  margin: 3.2rem 0 1.6rem 0;
  font-size: ${fontSize.LARGE_XXXL};
  width: 100%;
  padding: 0 2.4rem;

  ${media.desktop} {
    text-align: center;
    line-height: 1;
    text-align: center;
    color: ${color.GREYISH_BROWN};
    margin: 3.2rem 0 0.8rem 0;
  }
`

export const Paragraph = styled.p`
  font-size: ${fontSize.NORMAL};
  line-height: 1.5;
  color: ${color.WARM_GREY};
  margin: 0;
  width: 100%;
  padding: 0 2.4rem;

  ${media.desktop} {
    text-align: center;
  }
`
